/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeInstructionGenerationDto
 */
export interface FinalizeInstructionGenerationDto {
    /**
     * Instruction ID
     * @type {string}
     * @memberof FinalizeInstructionGenerationDto
     */
    instructionId: string;
    /**
     * Instruction timezone
     * @type {string}
     * @memberof FinalizeInstructionGenerationDto
     */
    timezone?: string;
}

/**
 * Check if a given object implements the FinalizeInstructionGenerationDto interface.
 */
export function instanceOfFinalizeInstructionGenerationDto(value: object): value is FinalizeInstructionGenerationDto {
    if (!('instructionId' in value) || value['instructionId'] === undefined) return false;
    return true;
}

export function FinalizeInstructionGenerationDtoFromJSON(json: any): FinalizeInstructionGenerationDto {
    return FinalizeInstructionGenerationDtoFromJSONTyped(json, false);
}

export function FinalizeInstructionGenerationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeInstructionGenerationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instructionId': json['instructionId'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function FinalizeInstructionGenerationDtoToJSON(json: any): FinalizeInstructionGenerationDto {
    return FinalizeInstructionGenerationDtoToJSONTyped(json, false);
}

export function FinalizeInstructionGenerationDtoToJSONTyped(value?: FinalizeInstructionGenerationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instructionId': value['instructionId'],
        'timezone': value['timezone'],
    };
}

